import React from 'react';
import PersonNameField from './fields/PersonNameField';
import AddressField from './fields/AddressField';
import DocumentDateField from './fields/DocumentDateField';
import DocumentTypeField from './fields/DocumentTypeField';
import EmailField from './fields/EmailField';

const FieldRenderer = ({ field, value, error, onChange, files, onFileChange }) => {
  const commonProps = {
    field,
    value,
    error,
    onChange
  };

  switch (field.type) {
    case 'person_name':
      return <PersonNameField {...commonProps} />;
      
    case 'us_address':
      return <AddressField {...commonProps} />;
      
    case 'document_date':
      return <DocumentDateField {...commonProps} />;
      
    case 'document_type':
      return <DocumentTypeField {...commonProps} />;
      
    case 'email':
      return <EmailField {...commonProps} />;
      
    case 'document_file':
      // File uploads are handled in FileUploadSection
      return null;
      
    default:
      return (
        <div key={field.id} className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {field.title}
            {field.required && <span className="text-red-500 ml-1">*</span>}
          </label>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              error ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {error && (
            <p className="text-sm text-red-600 mt-1">{error}</p>
          )}
        </div>
      );
  }
};

export default FieldRenderer;